import moment from 'moment'
import { getTokenCurrentUser } from '@/utils/auth'
import { encode_bs64 } from '@/utils/general'

const formatDataNotification = ( data ) =>{
    const encodeId = encode_bs64(`NotificationNode:${data.id}`)
    return {
        id: encodeId,
        title: data.title,
        subtitle: data.subtitle,
        text: data.text,
        created: moment().format('LLL'),
        recipient: data.recipient,
        products: data.products,
        read: false
    }
}

export const state = {
    socket: null,
    allNotifications: [],
    noveltyCount: localStorage.getItem('noveltyValue') || 0, // Contador de nuevas novedades
    retreatCount: localStorage.getItem('retreatValue') || 0, // Contadoe de nuevas solicitudes de retiro
    walletBalance: localStorage.getItem('walletBalance') || 0, 
}

export const mutations = {
    SET_SOCKET(state, socket){
        state.socket = socket
    },
    SET_NOTIFICATIONS(state, data){
        const tempNotifications = []
        for (let item of data.data){
            const index = state.allNotifications.findIndex(notify => notify.id === item.id)
            if (index === -1){
                tempNotifications.push(item)
            }
        }
        if (data.type === 'websocket'){
            state.allNotifications.unshift(...tempNotifications)
        }else{
            state.allNotifications.push(...tempNotifications)
        }
    },
    READ_NOTIFICATION(state, notification_id){
        const index = state.allNotifications.findIndex(notify => notify.id === notification_id)
        const notification = state.allNotifications[index]
        notification.read = true
        state.allNotifications[index] = notification
    },
    // Novedades
    INCREASE_NOVELTY_COUNT(state){
        state.noveltyCount++
    },
    RESET_NOVELTY_COUNT(state){
        state.noveltyCount = 0
        localStorage.removeItem('noveltyValue')
    },
    SET_NOVELTY_COUNT_VALUE(state, value){
        state.noveltyCount = value
        localStorage.setItem('noveltyValue', state.noveltyCount)
    },
    // Fin novedades
    // Solicitud de retiro
    SET_RETREAT_COUNT_VALUE(state, value){
        state.retreatCount = value
        localStorage.setItem('retreatValue', state.retreatCount)
    },
    RESET_RETREAT_COUNT(state){
        state.retreatCount = 0
        localStorage.removeItem('retreatValue')
    },
    // Fin solicitud de retiro
    
    SET_VALUE_WALLET_BALANCE(state, balanceValue){
        state.walletBalance = balanceValue
        localStorage.setItem('walletBalance', balanceValue)
    },
    RESET_WALLET_BALANCE(state){
        state.walletBalance = 0
        localStorage.removeItem('walletBalance')
    }
}

export const actions = {
    connectSocket({ commit }){
        const token = getTokenCurrentUser()
        const protocol = window.location.protocol === 'https:' ? 'wss://': 'ws://'
        const socketUrl = `${protocol}${window.location.host.split('.')[0]}.${process.env.VUE_APP_SOCKET_URL}/ws/notifications?authorization=Bearer ${token}`
        const socket = new WebSocket(socketUrl)
        socket.onmessage = ( info ) => {
            const { data } = info
            const dataParse = JSON.parse(data)
            if (dataParse.type === 'notification'){
                const formatedData = formatDataNotification(dataParse)
                commit('SET_NOTIFICATIONS', {data: [formatedData], type: 'websocket'})
                return
            }
            if (dataParse.type === 'newNovelty'){
                commit('SET_NOVELTY_COUNT_VALUE', dataParse.noveltyCount)
                return 
            }
            if(dataParse.type === 'newRetreat'){
                commit('SET_RETREAT_COUNT_VALUE', dataParse.retreatCount)
                return 1
            }
            if(dataParse.type === 'transactionWallet'){
                commit('SET_VALUE_WALLET_BALANCE', dataParse.value)
                return 1
            }
        }
        commit('SET_SOCKET', socket)
    },
    
}
export const getters = {
    hasSocket(state){
        return !!state.socket
    },
    listNotifications(state){
        return state.allNotifications
    },
    getSocket(state){
        return state.socket
    },
    countNotifications(state){
        return state.allNotifications.filter(notify => notify.read === false).length
    },
    noveltyCount(state){
        return state.noveltyCount
    },
    retreatCount(state){
        return state.retreatCount
    },
    walletBalance(state){
        return state.walletBalance
    }

}